<template>
  <btn
  :small="small"
  :active="value"
  @click="$emit('update', !value)"
  class="checkBtn"
  >
    <slot/>
  </btn>
</template>

<script>
import btn from './btn'
export default {
  name: 'checkBtn',
  components: {
    btn,
  },
  model:{
    prop: 'value',
    event: 'update',
  },
  props: {
    value: Boolean,
    small: Boolean,
  },
}
</script>

<style lang="scss">
@import '../assets/css/common.scss';

.checkBtn {
  margin: 0 1rem 2.4rem 0;
}
</style>
